import { createRoot } from '@wordpress/element';
import BitesPanel from '@components/Bites/BitesPanel';

const App = () => {
  return <BitesPanel />;
};

const el = document.getElementById('blockbite-bites');
const root = createRoot(el);
root.render(<App />);
